// Surface Current Density units with conversion factors to ampere per square meter (A/m²)
export const surfaceCurrentDensityUnits = [
  { id: 'ampere-per-square-meter', name: 'Ampere per Square Meter', symbol: 'A/m²', plural: 'Amperes per Square Meter', factor: 1 },
  { id: 'ampere-per-square-centimeter', name: 'Ampere per Square Centimeter', symbol: 'A/cm²', plural: 'Amperes per Square Centimeter', factor: 10000 },
  { id: 'ampere-per-square-millimeter', name: 'Ampere per Square Millimeter', symbol: 'A/mm²', plural: 'Amperes per Square Millimeter', factor: 1000000 },
  { id: 'ampere-per-square-inch', name: 'Ampere per Square Inch', symbol: 'A/in²', plural: 'Amperes per Square Inch', factor: 1550.0031 },
  { id: 'milliampere-per-square-meter', name: 'Milliampere per Square Meter', symbol: 'mA/m²', plural: 'Milliamperes per Square Meter', factor: 0.001 },
  { id: 'milliampere-per-square-centimeter', name: 'Milliampere per Square Centimeter', symbol: 'mA/cm²', plural: 'Milliamperes per Square Centimeter', factor: 10 },
  { id: 'kiloampere-per-square-meter', name: 'Kiloampere per Square Meter', symbol: 'kA/m²', plural: 'Kiloamperes per Square Meter', factor: 1000 },
  { id: 'abampere-per-square-meter', name: 'Abampere per Square Meter', symbol: 'abA/m²', plural: 'Abamperes per Square Meter', factor: 10 },
  { id: 'abampere-per-square-centimeter', name: 'Abampere per Square Centimeter', symbol: 'abA/cm²', plural: 'Abamperes per Square Centimeter', factor: 100000 },
];

export const popularSurfaceCurrentDensityConversions = [
  { from: 'ampere-per-square-meter', to: 'ampere-per-square-centimeter' },
  { from: 'ampere-per-square-centimeter', to: 'ampere-per-square-meter' },
  { from: 'ampere-per-square-meter', to: 'ampere-per-square-millimeter' },
  { from: 'ampere-per-square-meter', to: 'ampere-per-square-inch' },
  { from: 'milliampere-per-square-centimeter', to: 'ampere-per-square-meter' },
  { from: 'ampere-per-square-meter', to: 'milliampere-per-square-meter' },
];

export const getUnitById = (id) => surfaceCurrentDensityUnits.find(unit => unit.id === id);

export const convertSurfaceCurrentDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert surface current density units and learn the conversion formula.`;
};
